@use "../../../sass/variables/colors";
@use "../../../sass/variables/dimensions";

.ux-modal-content {
  display: block;
  flex: 1 1 auto;
  overflow: auto;
  padding: 0 dimensions.$dim-30 dimensions.$dim-30;
  width: 100%;

  p {
    color: colors.$color-gray-text;
  }
}
